export const deepClone = (obj: object): object | [] => {
  if (obj == null) return obj;

  const clone = Array.isArray(obj) ? [] : {};

  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    clone[key] = (typeof value === 'object') ? deepClone(value) : value;
  });

  return clone;
};

export default deepClone;
